/*var swiper = new Swiper(".cards-carousel-flip", {

    loop: true,
    slidesPerView: 1.5,
    spaceBetween: 10,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
});
*/


var swiper = new Swiper("#cards-carousel-flip", {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 24,
    navigation: {
        nextEl: "#swiper-button-next",
        prevEl: "#swiper-button-prev",
    },
    pagination: {
        el: "#swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        440: {
            slidesPerView: 1.5,
        },
        560: {
            slidesPerView: 2.5,
        },
        768: {
            slidesPerView: 2.5,
        },
        1024: {
            slidesPerView: 3.5,
        },
        1320: {
            slidesPerView: 4,
        },
    }    
  });